import React from "react";
import { Check, ArrowRight, Shield, Zap, Database } from "lucide-react";
import "../hostingplans.css";

const HostingPlans = () => {
    const plans = [
    {
        name: "Starter Hosting",
        price: "$35.99",
        period: "/month",
        description: "👉 Best for brochure websites & startups",
        features: [
        "10GB SSD Storage",
        "100GB Monthly Bandwidth",
        "Free SSL (secure website)",
        "cPanel acess",
        "99.9% Uptime Guarantee",
        "Managed setup & Basic Support",
        "Free website migration"
      ],
      popular: false,
      ctaText: "Start with Starter",
      icon: <Database size={24} />,
    },
    {
      name: "Business Hosting",
      price: "$45.99",
      period: "/month",
      description: "👉 Perfect for service businesses & lead-generation sites",
      features: [
        "50GB SSD Storage",
        "Unlimited Monthly Bandwidth",
        "Free SSL",
        "Advanced cPanel Features",
        "Daily Automated Backups",
        "99.9% Uptime Guarantee",
        "Priority Support(real human help",
        "Free Domain (1 year)",
        "Performance optimization included",
      ],
      popular: true,
      ctaText: "Choose Business",
      icon: <Zap size={24} />,
    },
    {
      name: "Pro Hosting",
      price: "$59.99",
      period: "/month",
      description: "👉 Best for e-commerce, booking systems & scaling brands",
      features: [
        "100GB SSD Storage",
        "Unlimited Monthly Bandwidth",
        "Free SSL",
        "Premium cPanel Features",
        "Daily Automated Backups",
        "99.9% Uptime Guarantee",
        "24/7 Priority Support",
        "Free Domain (1 year)",
        "Advanced Security Features",
        "Performance Monitoring",
        "Free domain(1 year)",
        "Website health monitoring"
      ],
      popular: false,
      ctaText: "Go Pro",
      icon: <Shield size={24} />,
    },
  ];

  const scrollToContact = () => {
    const element = document.getElementById("contact");
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <section id="hosting-plans" className="hosting-plans">
      <div className="hosting-container">
        <div className="hosting-header">
          <h2 className="hosting-title">Reliable Hosting Plans</h2>
          <p className="hosting-description">
            Fast, secure, and reliable hosting solutions designed to keep your
            website running at peak performance with 99.9% uptime guarantee.
          </p>
          <p className="hosting-description">All hosting plans include managed setup, security monitoring, and real support — not just server space.</p>
        </div>

        <div className="hosting-grid">
          {plans.map((plan, index) => (
            <div
              key={index}
              className={`hosting-card ${plan.popular ? "popular" : ""}`}
            >
              {plan.popular && (
                <div className="hosting-popular-badge">Most Popular</div>
              )}

              <div
                className={`hosting-header-content ${
                  plan.popular ? "with-badge" : ""
                }`}
              >
                <div
                  className={`hosting-icon ${
                    plan.popular ? "popular" : "standard"
                  }`}
                >
                  {plan.icon}
                </div>

                <h3 className="hosting-plan-name">{plan.name}</h3>
                <p className="hosting-plan-description">{plan.description}</p>

                <div className="hosting-price-container">
                  <span className="hosting-price">{plan.price}</span>
                  <span className="hosting-period">{plan.period}</span>
                </div>
              </div>

              <div className="hosting-content">
                <ul className="hosting-features">
                  {plan.features.map((feature, featureIndex) => (
                    <li key={featureIndex} className="hosting-feature">
                      <Check size={20} />
                      <span className="hosting-feature-text">{feature}</span>
                    </li>
                  ))}
                </ul>
              </div>

              <div className="hosting-footer">
                <button
                  onClick={scrollToContact}
                  className={`hosting-button ${
                    plan.popular ? "popular" : "standard"
                  }`}
                >
                  {plan.ctaText}
                  <ArrowRight size={16} />
                </button>
              </div>
            </div>
          ))}
        </div>

        <div className="hosting-why-choose">
          <div className="why-choose-card">
            <h3 className="why-choose-title">Why Choose OIGHosting?</h3>
            <div className="why-choose-grid">
              <div>
                <div className="why-choose-item-icon">
                  <Shield size={24} />
                </div>
                <h4 className="why-choose-item-title">Enterprise Security</h4>
                <p className="why-choose-item-description">
                  Advanced security measures to protect your website and data
                </p>
              </div>
              <div>
                <div className="why-choose-item-icon">
                  <Zap size={24} />
                </div>
                <h4 className="why-choose-item-title">Lightning Fast</h4>
                <p className="why-choose-item-description">
                  Optimized servers for maximum speed and performance
                </p>
              </div>
              <div>
                <div className="why-choose-item-icon">
                  <Database size={24} />
                </div>
                <h4 className="why-choose-item-title">99.9% Uptime</h4>
                <p className="why-choose-item-description">
                  Reliable infrastructure ensuring your site stays online
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HostingPlans;
